
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bots/guides",
      function () {
        return require("private-next-pages/bots/guides/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bots/guides"])
      });
    }
  